import d from "../../../../../@vue_babel-helper-vue-jsx-merge-props@1.4.0/node_modules/@vue/babel-helper-vue-jsx-merge-props/dist/helper.js";
import { inherit as l } from "../utils/functional.js";
import s from "../info/index.js";
import { createNamespace as g } from "../utils/create/index.js";
import { addUnit as u } from "../utils/format/unit.js";
var i = g("icon"),
  S = i[0],
  c = i[1];
function b(e) {
  return e ? e.indexOf("/") !== -1 : !1;
}
var N = {
  medel: "medal",
  "medel-o": "medal-o",
  "calender-o": "calendar-o"
};
function v(e) {
  return e && N[e] || e;
}
function m(e, r, a, f) {
  var n,
    t = v(r.name),
    o = b(t);
  return process.env.NODE_ENV === "development" && r.info && console.warn('[Vant] Icon: "info" prop is deprecated, use "badge" prop instead.'), e(r.tag, d([{
    class: [r.classPrefix, o ? "" : r.classPrefix + "-" + t],
    style: {
      color: r.color,
      fontSize: u(r.size)
    }
  }, l(f, !0)]), [a.default && a.default(), o && e("img", {
    class: c("image"),
    attrs: {
      src: t
    }
  }), e(s, {
    attrs: {
      dot: r.dot,
      info: (n = r.badge) != null ? n : r.info
    }
  })]);
}
m.props = {
  dot: Boolean,
  name: String,
  size: [Number, String],
  // @deprecated
  // should be removed in next major version
  info: [Number, String],
  badge: [Number, String],
  color: String,
  tag: {
    type: String,
    default: "i"
  },
  classPrefix: {
    type: String,
    default: c()
  }
};
var y = S(m);
export { y as default };
